module.exports = __webpack_public_path__ + "img/gr.760ef511.svg";